import { createActionNamespace } from '@util/redux-tools';

const { addActions } = createActionNamespace('[resources/tests]');

export default addActions({
  CHANGE_ALTERNATING_LETTERING: ['testId', 'value'],
  CHANGE_STATE: ['testId', 'state'],
  CREATE_QUESTION: ['testId', 'question', 'idx'],
  CREATE: ['test', 'view'],
  DELETE_QUESTION: ['testId', 'guid'],
  DELETE_RESOURCE: ['testId', 'guid'],
  LOAD_BY_ID_SUCCESS: ['test'],
  LOAD_BY_ID: ['id'],
  RELOAD_BY_ID: ['id'],
  REORDER_QUESTIONS: ['testId', 'questionArray'],
  SAVE_QUESTION: ['testId', 'question'],
  SAVE_QUESTIONS: ['testId', 'questions'],
  SAVE: ['test']
});
